import React from "react";
import { useQuery } from 'react-query'
import { getResultsRSC } from "data/Querys"
import Loader from 'components/general/Loader'
import NotAvailable from "components/common/NotAvailable";
import PageHeader from "components/common/PageHeader";
import WlfResult from "components/sports/wlf/views/WlfResult";
import CurrentCompetitor from "components/sports/wlf/views/CurrentCompetitor";
import PreviousCompetitor from "components/sports/wlf/views/PreviousCompetitor";
import RecordsPrototype from "components/general/RecordsPrototype";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import Label from "components/general/Label";
import Accordion from 'react-bootstrap/Accordion';

const WlfContext = () => {
  const { mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()

  //datos para el marcador y estadisticas
  const { data, isError, isLoading } = useQuery(
    {
      queryKey: ['resultsData', mirs_competition, mirs_rsc, mirs_language, null, null, ['WR', 'OR', 'JWR']],
      queryFn: getResultsRSC,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error']
    });

  if (isError) { return <NotAvailable /> }
  if (isLoading) { return <Loader /> }
  if (!data?.results) { return <NotAvailable /> }


  // Averiguamos los eventos distintos que se peuden superar
  let recordEvent = data?.records?.filter(item => (item.recordCode));
  let arrRecordEvent = recordEvent?.sort((a, b) => a.record?.order - b.record?.order).map((val) => { return (val.recordCode) });
  //Esto elimina duplicados
  const dataArr = new Set(arrRecordEvent);
  let arrRecordEventDistinct = [...dataArr];

  let recordsHead = arrRecordEventDistinct.map((row, index) => {
    let arrRecordEventDistinctOrder = data?.records?.filter(item => item.recordCode === row)
    let recordDescription = arrRecordEventDistinctOrder.length > 0 ? arrRecordEventDistinctOrder[0]?.record?.description : ''
    let recordType = arrRecordEventDistinctOrder.map((item, index) => {
      return (<div className="w-20" key={'Record-Type-' + index}>{item?.recordType?.group} {item?.recordData[0]?.result} <Label data='LabelKg' /></div>)
    })
    return (
      <div className="d-flex justify-content-start" key={'record-description-' + index} >
        <div className="w-40">{recordDescription}</div>
        {recordType}
      </div>
    )
  })

  let records = arrRecordEventDistinct.map((row, index) => {
    let arrRecordEventDistinctOrder = data?.records?.filter(item => item.recordCode === row)
    let recordDescription = arrRecordEventDistinctOrder.length > 0 ? arrRecordEventDistinctOrder[0]?.record?.description : ''
    return (
      <RecordsPrototype records={arrRecordEventDistinctOrder} headerRecord={recordDescription} key={'Component-record-' + index} />
    )
  })

  return (
    <>
      <PageHeader data={data} />

      <div className='mirs-page-container'>
      {data?.records && <Accordion className="accordion-records-discipline">
        <Accordion.Item eventKey="0">
          <Accordion.Header className="accordion-records-discipline-header">
            <div className="w-100">
              {recordsHead}
            </div>
          </Accordion.Header>
          <Accordion.Body>
            {records}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>}

      <PreviousCompetitor data={data} />
      <CurrentCompetitor data={data} />
      <WlfResult data={data} />
      </div>
    </>
  )

};

export default WlfContext;